export const CONTACT = {
  CONTACT_LISTING: {
    LABELS: {
      TITLE: 'Contacts',
      UPDATED_AT: 'updatedAt',
      LOAD_CONTACTS: 'Loading contacts...',
      EDIT_CONTACT: 'Edit Contact',
      ADD_CONTACT: 'Add Contact',
      DELETE: 'Delete ',
      DELETE_SELECTED_CONATACTS: 'Delete Selected Contacts',
      ROWS_SELECTED: 'rows selected',
      ROW_SELECTED: 'row selected',
      FILTERS: 'Filters',
    },
    PLACEHOLDERS: {
      SEARCH: 'Search by name, email, or phone',
    },
    BUTTONS: {
      IMPORT: 'Import',
      ADD_NEW: 'Add Contact',
      APPLY: 'Apply',
      CANCEL: 'Cancel',
    },
    TOAST_MESSAGE_SUCCESS: {
      CONTACT_STATUS: 'Contact status updated successfully',
      CONTACT_STAGE: 'Contact stage updated successfully',
      DELETE_CONTACT: 'Contact is deleted successfully',
      DELETE_CONTACTS: 'Contacts are deleted successfully',
      CONTACTS_EXPORTED: 'Contacts exported successfully.',
      ARCHIVE_CONTACT: 'Contact archived successfully.',
      ARCHIVE_CONTACTS: 'Contacts archived successfully.',
      UNARCHIVE_CONTACT: 'Contact unarchived successfully.', // ✅ Added
      UNARCHIVE_CONTACTS: 'Contacts unarchived successfully.',
      COLUMN_PREFERENCE: 'Column preferences saved successfully',
    },
    TOAST_MESSAGE_ERRORS: {
      CONTACT_STATUS: 'Failed to update - Invalid status-stage combinations',
      CONTACT_STAGE: 'Failed to update contact stage',
      DELETE_CONTACT: 'Unable to delete Contact. Please try again.',
      DELETE_CONTACTS: 'Failed to delete contacts',
      NO_CONTACTS_SELECTED: 'No contacts selected for export.',
      NO_DATA_AVAILABLE: 'No data available for export.',
      CONTACT_LIST: 'Failed to fetch the Contact list',
      ARCHIVE_CONTACT: 'Failed to archive contact',
      ARCHIVE_CONTACTS: 'Failed to archive contacts',
      UNARCHIVE_CONTACT: 'Failed to unarchive contact', // ✅ Added
      UNARCHIVE_CONTACTS: 'Failed to unarchive contacts',
      COLUMN_PREFERENCE: 'Failed to save column preferences',
      EXPORT_FAILED: 'Failed to export contacts',
    },
  },
  CONTACT_FORM: {
    PLACEHOLDERS: {
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      EMAIL: 'name@example.com',
      PHONE: '(123) 456-7890',
      DOB: 'MM/DD/YYYY',
      GENDER: 'Select Gender',
      ADDRESS_LINE1: 'Street Address',
      ADDRESS_LINE2: 'Apt, Suite, etc. (optional)',
      CITY: 'City',
      STATE: 'State/Province',
      COUNTRY: 'Country',
      ZIPCODE: 'ZIP/Postal code',
      NOTES: 'Add additional notes that may be relevant to your contact...',
      LIFE_TIME_VALUE: 'Lifetime Value',
      INSTAGRAM_HANDLE: 'Instagram Handle',
      FACEBOOK_HANDLE: 'Facebook Handle',
    },
    LABELS: {
      FIRST_NAME: 'First Name',
      LAST_NAME: 'Last Name',
      EMAIL: 'Email',
      PHONE: 'Phone',
      DOB: 'Date of Birth',
      GENDER: 'Gender',
      ADDRESS_LINE1: 'Address Line 1',
      ADDRESS_LINE2: 'Address Line 2',
      CITY: 'City',
      STATE: 'State',
      COUNTRY: 'Country',
      ZIPCODE: 'Zip Code',
      NOTES: 'Notes',
      SMS_OPT_IN: 'SMS Opt-In',
      EMAIL_OPT_IN: 'Email Opt-In',
      LIFE_TIME_VALUE: 'Lifetime Value',
      INSTAGRAM_HANDLE: 'Instagram Handle',
      FACEBOOK_HANDLE: 'Facebook Handle',
    },
    BUTTONS: {
      ADD: 'Add Contact',
      SAVE: 'Save Changes',
    },
    TOAST_MESSAGE_SUCCESS: {
      ADD_CONTACT: 'Contact Added',
      UPDATE_CONTACT: 'Contact Updated',
    },
    TOAST_MESSAGE_ERRORS: {
      ADD_CONTACT: 'Failed to Add Contact',
      UPDATE_CONTACT: 'Failed to Update Contact',
    },
  },
};
